import { ArrowDown } from '@quizzach/assets';
import {
	DropdownItem,
	DropdownStyle,
	SelectContainer,
	SelectLabelButton,
} from '@quizzach/styles';
import { useState } from 'react';

export const Select = ({
	label,
	values,
	onChange,
}: {
	label: string;
	values: string[];
	onChange?: (value: string) => void;
}) => {
	const [currentValue, setCurrentValue] = useState<string>('');
	const [open, setOpen] = useState<boolean>(false);

	const handleClick = () => {
		setOpen(!open);
	};

	const handleValueChange = (value: string) => {
		setCurrentValue(value);
	};

	const handleChange = (value: string) => {
		handleValueChange(value);
		if (onChange) onChange(value);
		handleClick();
	};

	return (
		<SelectContainer>
			<SelectLabelButton onClick={handleClick}>
				{currentValue !== '' ? currentValue : label}
				<ArrowDown height={5} />
			</SelectLabelButton>
			<DropdownStyle $visible={open}>
				{values.map((value, index) => (
					<DropdownItem
						onClick={() => handleChange(value)}
						$active={value === currentValue}
						key={index}
					>
						{value}
					</DropdownItem>
				))}
			</DropdownStyle>
		</SelectContainer>
	);
};
